export default "__VITE_ASSET__dCZa5ECN__"